import logo from "./logo.svg";
import "./App.css";
import "./index.css";
import React, { useState } from "react";
import Navbar from "./components/navbar";
import HeroCarousel from "./components/HeroCarousel";
import LegacySection from "./components/LegacySection";
import Programs from "./components/Programs";

import WelcomeSection from "./components/WelcomeSection";
import Recruiters from "./components/Recruiters";
import Flipper from "./components/Flipper";
// import NavbarWithFlipper from "./components/NavbarWithFlipper";

import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import LatestHappenings from "./components/LatestHappenings";
import EducationPartners from "./components/EducationPartners";
import CTAButton from "./components/sticky-button";
import VisionMission from "./components/components/VisionMission";
import Nirf from "./components/nirf";
import QuickAccess from "./components/quickAccess";

import BrochureForm from "./components/EnquiryForm";
import ContactAdmissionsStrip from "./components/ContactAdmissionsStrip";
import ExploreCampus from "./components/ExploreCampus";
import EventsWidget from "./components/EventsWidget";
// import BrochureForm from './components/BrochureForm';

// import stickyButton from './components/sticky-button';
// import ContactUsTab from './components/ContactUsTab';
// import HeroSection from './components/HeroSection.jsx';
// import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  const [showForm, setShowForm] = useState(false);

  return (
    <div className="App">
      {/* 1. This must be inside the return block */}
      {showForm && <BrochureForm setShowForm={setShowForm} />}

      {/* 2. Pass the handler to Navbar so those buttons work too */}
      <Navbar setShowForm={setShowForm} />

      <div>
        <CTAButton />
        <WelcomeSection />
      </div>

      <QuickAccess />

      <VisionMission />
      <Nirf />
      <Programs />
      <ExploreCampus />
      <div className="section-base">
        <Recruiters />
      </div>
      <EventsWidget />
      <Testimonials />

      <div className="section-base">
        <div className="page-container">
          <LatestHappenings />
        </div>
      </div>
      <EducationPartners />
      <ContactAdmissionsStrip onAppointmentClick={() => setShowForm(true)} />
      <Footer />
    </div>
  );
}
export default App;
